import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './utils';
import { EnrollmentPreview } from 'src/frontend-common/dto/Interfaces/ILogins';

interface NotificationsStatus {
  is_subscribed_to_product_updates: boolean;
  is_subscribed_to_status_page: boolean;
}

interface NotificationsStatusResponse {
  item: {
    username: string;
    is_subscribed_to_status_page: boolean;
    is_subscribed_to_product_updates: boolean;
  };
}

export const notificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: baseQuery,
  tagTypes: ['NotificationsStatus', 'Logins', 'Enrollments'],
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getNotificationsStatus: builder.query<NotificationsStatusResponse, void>({
      query: () => ({
        url: '/v1/user-preference',
      }),
      providesTags: ['NotificationsStatus'],
    }),
    updateNotificationsStatus: builder.mutation<NotificationsStatusResponse, NotificationsStatus>({
      query(data) {
        return {
          url: '/v1/user-preference',
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: ['NotificationsStatus'],
    }),
    trackEnrollment: builder.mutation<EnrollmentPreview, { sessionId: string; appKey: string }>({
      query: ({ sessionId, appKey }) => {
        const envValue = process.env.REACT_APP_API_SERVICE_HOST;
        return {
          url: `https://${envValue}/1.0/track/enrollments`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': appKey,
          },
          params: { session_id: sessionId },
          body: {},
        };
      },
      invalidatesTags: ['Enrollments'],
    }),
  }),
});

export const { useGetNotificationsStatusQuery, useUpdateNotificationsStatusMutation, useTrackEnrollmentMutation } = notificationApi;
